// src/utils/utils_pollAdminRefresh.ts
//
// Le header (Header.tsx) lit authentication.admin directement — il se met à jour tout
// seul dès que ce champ change en Redux, refreshAdmin() (déjà utilisé ailleurs après une
// bascule de chaîne) suffit à le déclencher. Le problème n'est pas LE mécanisme mais LE
// MOMENT : le quota n'est crédité qu'au webhook PayPal/Stripe (SubscriptionNotification /
// PaymentNotification), qui arrive après coup — un seul refreshAdmin() juste après avoir
// vu "Paiement confirmé" lit encore souvent l'ancien quota. Faute de pouvoir attendre CE
// webhook précis depuis le front, on retente plusieurs fois avec un délai croissant :
// grossier, mais s'aligne sur un délai qu'on ne maîtrise pas plutôt que de le deviner.

import { store        }  from "../store/store";
import { refreshAdmin }  from "../store/adminAuthenticationManagment/actions";

const POLL_DELAYS_MS = [2000, 5000, 10000, 20000];

export function pollAdminRefreshAfterPurchase(email: string): void {
  if (!email) return;

  store.dispatch(refreshAdmin(email));

  POLL_DELAYS_MS.forEach((delay) => {
    setTimeout(() => store.dispatch(refreshAdmin(email)), delay);
  });
}
